import ComplaintForm from './ComplaintForm';

export {ComplaintForm}



// WEBPACK FOOTER //
// ./components/users/sub-view/complaint-form/index.js